// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3jfZ4","label":"SetPasswdForm_label__3j8wq"};